export default {
    radians (degrees) {
        return degrees / 180 * Math.PI
    },
    degrees (radians) {
        return radians * 180 / Math.PI
    }
}



// WEBPACK FOOTER //
// ./src/plugins/Angles.js